import { Pipe, PipeTransform } from '@angular/core';
import { getAcceptDisplayText } from './files';

@Pipe({ name: 'fileAcceptDisplay' })
export class FileAcceptDisplayPipe implements PipeTransform {
  transform(accept: string, separator: string = ' or '): string {
    return getAcceptDisplayText(accept, separator);
  }
}
